/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ShipmentReportSettlementStatus {
  Projected = "projected",
  Open = "open",
  Approved = "approved",
  Settled = "settled",
}

export function instanceOfShipmentReportSettlementStatus(value: any): boolean {
  for (const key in ShipmentReportSettlementStatus) {
    if (
      Object.prototype.hasOwnProperty.call(ShipmentReportSettlementStatus, key)
    ) {
      if (
        ShipmentReportSettlementStatus[
          key as keyof typeof ShipmentReportSettlementStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentReportSettlementStatusFromJSON(
  json: any,
): ShipmentReportSettlementStatus {
  return ShipmentReportSettlementStatusFromJSONTyped(json, false);
}

export function ShipmentReportSettlementStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentReportSettlementStatus {
  return json as ShipmentReportSettlementStatus;
}

export function ShipmentReportSettlementStatusToJSON(
  value?: ShipmentReportSettlementStatus | null,
): any {
  return value as any;
}

export function ShipmentReportSettlementStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentReportSettlementStatus {
  return value as ShipmentReportSettlementStatus;
}
